<template>
	<div>
		<div>
			<b-row>
				<b-col xl="12">

					<div><br>
						The first line of the import file must contain the names of the fields. Any duplicates will be
						replaced with theses values in the inventory.
					</div><br>

					<b-row class="text-md-center">

						<b-col>&nbsp;</b-col>
						<b-col>
							<b-checkbox
                data-cy="ota-import-remove-toggle"
								v-model="removeInventory"
								switch
							>
								Remove Inventory
							</b-checkbox>
						</b-col>

						<b-col>
							<b-checkbox
								v-model="addEsim"
								switch
							>
								Add ESIM
							</b-checkbox>
						</b-col>

						<b-col>
							<b-checkbox
								v-model="activateOta"
								switch
							>
								Activate Ota
							</b-checkbox>
						</b-col>

						<b-col>
							<b-checkbox
								v-if="!removeInventory"
								v-model="force"
								:disabled="removeInventory"
								switch
							>
								Overwrite (force)
							</b-checkbox>
						</b-col>
						<b-col>&nbsp;</b-col>
					</b-row>

					<b-row class="mb-4 mt-2">
						<b-col lg="8">
							<div class="input-group importFileGroup mb-3">
								<b-input-group>
									<template #prepend>
										<b-input-group-text :style="ps">Import File</b-input-group-text>
									</template>
									<b-form-file
										v-model="importFile"
										placeholder="Choose a file or drop it here...(.csv,.xls,.xlsx)"
										drop-placeholder="Drop file here..."
										accept=".csv,.xls,.xlsx"
										@change="onLoadFileData($event)"
										:state="importFileValidation"
									>
										<template
											v-slot:drag-drop="{ isDragging, isFileOver, hasFile, files, listeners }">
											<div
												:class="['dropzone', { 'is-dragging': isDragging, 'is-file-over': isFileOver }]"
												v-bind="listeners"
											>
												<p v-if="isDragging">Drop your file here</p>
												<p v-else-if="hasFile">{{ files.length }} file(s) selected</p>
												<p v-else>Drag your file here or click to choose a file</p>
											</div>
										</template>
									</b-form-file>
								</b-input-group>
							</div>
						</b-col>
						<b-col v-if="!removeInventory" lg="4" class="flex">
							<base-button
								:disabled="invalidData"
								:type="invalidData?'warning':'success'"
								v-on:click="processBatchImport">
								<span v-if="checkRunning">
									Checking Range <i class="fa fa-spinner fa-spin"></i>
								</span>
								<span v-else>
									Upload <i class="fa fa-upload" aria-hidden="true"></i>
								</span>
							</base-button>
							<base-button
								:type="'danger'"
								v-on:click="clearData">
								Clear File
							</base-button>
						</b-col>
						<b-col v-else>
							<base-button
								type="warning"
								v-on:click="confirmRemoveInventory"
								:disabled="invalidData"
							>
								Remove Inventory
							</base-button>

							<base-button
								:type="'danger'"
								v-on:click="clearData">
								Clear Data
							</base-button>

						</b-col>
					</b-row>

					<b-row v-if="showPreviewData">
						<b-col xl="9">
							<div class="text-sm-right">Search:</div>
						</b-col>
						<b-col xl="3">
							<b-input v-model="filter" size="sm" placeholder="Filter table.."></b-input>
						</b-col>
					</b-row>
					<b-row v-if="showPreviewData">
						<b-col xl="12">
							<div class="table-responsive">
								<b-table
									class="primary-table"
									head-row-variant="primary-table"
									id="previewTable"
									sticky-header="true"
									:busy="isLoading"
									:items="preview_items"
									:tbody-tr-class="rowClass"
									:current-page="currentPage"
									:filter="filter"
									:per-page="perPage"
									show-empty
									striped
									hover
								>
								</b-table>
								<!-- <b-pagination
									v-if="preview_items.length>10"
									v-model="currentPage"
									:total-rows="preview_items.length"
									per-page="10">
								</b-pagination> -->
								<b-row class="mt-4" v-if="preview_items.length > 0">
									<b-col> Showing {{ startPage() }} - {{ lastPage() }} of {{ totalRows }} entries
									</b-col>
									<b-col xl="auto" md="auto" sm="auto ">
										<b-pagination
											v-if="preview_items.length>10"
											class="flex-fill-custom pr-4"
											v-model="currentPage"
											:total-rows="totalRows"
											:per-page="perPage"
											size="sm"
										></b-pagination>
									</b-col>
								</b-row>
							</div>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</div>

		<!-- batch_progress_bar -->
		<b-modal
			centered
			size="sm"
			:id="'ota_batch_progress_bar_'+carrier.name"
			title="Progress">
			<div class="text-center">
				<b-progress
					:max="totalCnt"
					show-progress
					height="2rem"
					class="w-100 mb-2">
					<b-progress-bar :value="currentCnt">
						<div class="ml-2"><strong>{{ currentCnt }} of {{ totalCnt }}</strong></div>
					</b-progress-bar>
				</b-progress>
			</div>
			<div class="text-center">
				<small class="text-center">Processing ICCID: {{ iccid }}</small>
			</div>
			<template #modal-footer>
				<div class="text-break w-100">
					<small class="text-center text-wrap">{{ currentStatus }}</small>
					<br>
					<b-button
						v-if="!cancelAction"
						class="mt-3 w-100"
						variant="primary"
						block
						@click="cancelAction = true"
					>
						Cancel
					</b-button>
				</div>
			</template>
		</b-modal>

		<!-- ota_batch_progress_report -->
		<b-modal
			centered
			size="sm"
			:id="'ota_batch_progress_report_'+carrier.name"
			hide-footer
			header-bg-variant="info"
		>
			<template #modal-title>
				<span v-if="!removeInventory">Batch Import Results</span>
				<span v-else>Batch Remove Inventory Results</span>
			</template>
			<div class="text-left mt-3">
				<p class="h4">Processed Total: {{ currentCnt }}</p>
			</div>
			<div class="text-left mt-3">
				<p class="h4">{{ success.length }} <span class="text-success">Successful</span></p>
			</div>
			<div class="text-left">
				<p class="h4">{{ errors.length }} <span class="text-danger">Failed</span></p>
			</div>
			<div class="text-left">
				<p class="h5">
					Please
					<vue-json-to-csv :json-data="reportData" :csv-title="processTitle">
						<span class="text-primary cursor-pointer">click here</span>
					</vue-json-to-csv>
					to download a detailed list of processed SIMs.
				</p>
				<p class="h5">File Name :
					<vue-json-to-csv :json-data="reportData" :csv-title="processTitle">
						<span class="text-primary cursor-pointer">{{ processTitle + ".csv" }}</span>
					</vue-json-to-csv>
				</p>

			</div>
		</b-modal>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import otaDashboardService from "@/common/api-services/ota-dashboard-service";
import * as XLSX from "xlsx";
import moment from "moment";
import VueJsonToCsv from "vue-json-to-csv";
import commonService from "@/common/api-services/common";
import initService from "@/common/api-services/init-service";
import swal from "sweetalert2";
import coreutils from "@/common/coreutils";
import pagination from "../../../../common/format/pagination";

export default {
	name: "otaBatch",
	components: {RouteBreadCrumb, VueJsonToCsv},
	props: {
		carrier: {
			type: Object,
			required: true,
		},
		active_carrier: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			showPreviewData: false,
			preview_items: [],
			ps: "background-color: rgba(94,114,228) !important;color: #FFFFFF !important;",
			currentCnt: 0,
			totalCnt: 0,
			currentStatus: "",
			file: File,
			arrayBuffer: null,
			filelist: null,
			importFile: null,
			actionOption: [{value: "active", text: "Activate OTA"}],
			simImportRow: [],
			vendor: "",
			kic: "17A3F3410FB00DEEE9D0E767A10DCBC6",
			kid: "65D8E0BA794E7EBC981A7FA5E886A9D7",
			iccid: "",
			importData: [],
			importDataLength: 0,
			success: [],
			errors: [],
			progressStartValue: 5,
			onProgress: false,
			processTitle: "",
			reportData: [],
			invalidData: true,
			isLoading: false,
			perPage: 10,
			currentPage: 1,
			filter: "",
			range: [],
			active: false,
			removeInventory: false,
			force: false,
			vendorDisplayName: "",
			overwriteable: false,
			checkRunning: false,
			cancelAction: false,
			addEsim: false,
			activateOta: false
		};
	},

	computed: {
		coreutils() {
			return coreutils;
		},
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
		totalRows() {
			return this.preview_items.length;
		},
		importFileValidation() {
			return !this.invalidData && this.importFile !== null;
		},

		carrierValidation() {
			return (this.carrier !== "" || commonService.validateData("carrier", this.carrier));
		},

		vendorValidation() {
			return true;
			// return (this.vendor === "" || commonService.validateData('vendor', this.vendor));
		},

		kicValidation() {
			return (this.kic === "" || commonService.validateData("kic", this.kic));
		},

		kidValidation() {
			return (this.kid === "" || commonService.validateData("kid", this.kid));
		},
	},
	mounted() {
		document.title = "ota - Batch Loader";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}

		this.processTitle = moment(new Date()).format("YYYY-MM-DD") + "_processed";

	},
	methods: {


		rowClass(item, type) {
			if (!item) return;
			if (type !== "row") return "table-info";
			if (JSON.stringify(item).includes("INVALID")) return "table-danger";
		},

		loadPreviewData() {
			if (this.active_carrier !== this.carrier.name) return;

			this.isLoading = true;
			this.showPreviewData = true;
			this.preview_items = [];
			//format the import data
			let cnt = 0;
			Object.keys(this.importData).forEach(idx => {
				let row = this.formatDataRow(this.importData[idx]);
				 console.log("row:", row)
				if (row && row[0] && row[0]["iccid"]) {
					this.showPreviewData = true;
					this.preview_items.push(row[0]);
					cnt++;
				}
			});
			//check invalid data
			if (JSON.stringify(this.preview_items).includes("INVALID")) {
				this.invalidData = true;
				this.isLoading = false;
				let message = "NOTICE: The import identified ERRORS in the data.  Please review below.";
				this.filter = "INVALID";
				this.$toast(message, {type: "error"});
			}
			if (this.removeInventory) {
				this.isLoading = false;
				this.invalidData = false;
				return;
			}
			//now check the iccid to see if the carrier/vendor matches the iccid
			if (this.preview_items.length > 0) {
				//on first row clear the preview data and check kic/kid
				if (this.preview_items[0]["kic"] === this.kic || this.preview_items[0]["kid"] === this.kid) {
					let message = `NOTICE: The KIC/KID values are set to DCC defaults.`;
					this.$toast(message, {type: "warning"});
				}
			}
			//check start and end range
			if (this.preview_items.length > 0) {
				(async () => {
					await this.inventoryCheck(this.preview_items[0].iccid, this.preview_items[this.preview_items.length - 1].iccid);
				})();
			}
			this.isLoading = false;
		},

		async inventoryCheck(startIccid, endIccid) {
			if (this.active_carrier !== this.carrier.name) return;
			this.checkRunning = true;
			this.overwriteable = false;
			// console.log("inventoryCheck", startIccid, endIccid);
			let rangeStart = startIccid.toString().slice(0, -1);
			let rangeEnd = endIccid.toString().slice(0, -1);
			//now do a range check only for first item and last item.
			let errors = [];

			const start1 = await otaDashboardService.inventory_check(startIccid);
			// console.log(`inventory_check ${startIccid}`, start1.data.result);
			// const start1 = await otaDashboardService.inventory_check(rangeStart);
			// console.log(`inventory_check ${rangeStart}`, start1.data.result);
			const end1 = await otaDashboardService.inventory_check(endIccid);
			// console.log(`inventory_check ${endIccid}`, end1.data.result);
			// const end1 = await otaDashboardService.inventory_check(rangeEnd);
			// console.log(`inventory_check ${rangeEnd}`, end1.data.result);
			const start2 = await otaDashboardService.query_minimal(startIccid);
			// console.log(`query_minimal ${startIccid}`, start2.data.result);
			const end2 = await otaDashboardService.query_minimal(endIccid);
			// console.log(`query_minimal ${endIccid}`, end2.data.result);
			if (start1.data.error_string) {
				errors.push("FIRST_ERROR_" + start1.data.error_string.replaceAll(" ", "_").toUpperCase());
			} else {
				if (!start1.data.result.carrier || start1.data.result.carrier === "" || start1.data.result.carrier === "null") {
					errors.push("FIRST_NEW_RANGE");
				}
				if (start1.data.result.carrier !== this.carrier.name) {
					errors.push("FIRST_CARRIER_MISMATCH");
				}
				if (start1.data.result.vendor !== this.carrier.vendor) {
					errors.push("FIRST_VENDOR_MISMATCH");
				}
			}

			if (end1.data.error_string) {
				errors.push("LAST_ERROR_" + end1.data.error_string.replaceAll(" ", "_").toUpperCase());
			} else {
				if (!end1.data.result.carrier || end1.data.result.carrier === "" || end1.data.result.carrier === "null") {
					errors.push("LAST_NEW_RANGE");
				}
				if (end1.data.result.carrier !== this.carrier.name) {
					errors.push("LAST_CARRIER_MISMATCH");
				}
				if (end1.data.result.vendor !== this.carrier.vendor) {
					errors.push("LAST_VENDOR_MISMATCH");
				}
				if (end1.data.result.iccid === endIccid) {
					errors.push("LAST_EXISTING_RANGE");
				}
			}

			if (start2.data.error_string) {
				errors.push("FIRST_ERROR_" + start2.data.error_string.replaceAll(" ", "_").toUpperCase());
			} else {
				if (start2.data.result.iccid === startIccid && !JSON.stringify(errors).includes("NEW_RANGE")) {
					errors.push("FIRST_EXISTING_RANGE_" + start2.data.result.carrier.name);
					if (start2.data.result.carrier.name !== this.carrier.name) {
						errors.push("FIRST_CARRIER_MISMATCH_" + start2.data.result.carrier.name);
					}
				}
			}

			if (end2.data.error_string) {
				errors.push("LAST_ERROR_" + end2.data.error_string.replaceAll(" ", "_").toUpperCase());
			} else {
				if (end2.data.result.iccid === endIccid && !JSON.stringify(errors).includes("NEW_RANGE")) {
					errors.push("LAST_EXISTING_RANGE_" + end2.data.result.carrier.name);
					if (end2.data.result.carrier.name !== this.carrier.name) {
						errors.push("LAST_CARRIER_MISMATCH_" + end2.data.result.carrier.name);
					}
				}
			}
			this.checkRunning = false;
			const vendors = await otaDashboardService.getVendors();
			if (vendors && vendors.data && vendors.data.result) {
				vendors.data.result.forEach(vendor => {
					if (vendor.name === this.carrier.vendor) {
						this.vendorDisplayName = vendor.display_name;
					}
				});
			}
			let carrierDisplayName = this.carrier.display_name ? this.carrier.display_name : this.carrier.name;
			console.log(`range_errors: `, errors);
			if (errors.length < 1) {
				// VALID Range for this carrier
				this.$toast("The ICCID ranges appear to be valid.", {type: "success"});
				this.invalidData = false;
				return null;
			} else if (JSON.stringify(errors).includes("NEW_RANGE") && !JSON.stringify(errors).includes("EXISTING_RANGE")) {
				swal.fire({
					title: `RANGE MISSING`,
					html: `<div align="left">
									It appears that this range is not yet registered to a carrier.<br><br>
									Would you like to create this new range? <br><br>
									<b>carrier:</b>${carrierDisplayName}<br>
									<b>vendor:</b>${this.vendorDisplayName}<br>
									<b>first:</b>${rangeStart}<br>
									<b>last:</b>${rangeEnd}<br><br>
									ERRORS: ${JSON.stringify(errors).replaceAll("\"", "").replaceAll("[", "<br>").replaceAll("]", "").replaceAll(",", "<br>")}
								</div>`,
					showCloseButton: true,
					showCancelButton: true,
					confirmButtonText: `Add New Range`,
					cancelButtonText: "Cancel",
					customClass: {
						cancelButton: "order-1 mr-3",
						confirmButton: "btn btn-danger order-2",
					},
				}).then(result => {
					if (result.isConfirmed) {
						let payload = {
							carrier: this.carrier.name,
							iccid_start: rangeStart,
							iccid_end: rangeEnd,
							source: this.file.name,
							force: 1,
						};
						otaDashboardService.addIccidRange(payload).then(res => {
							if (res && res.data.status) {
								this.invalidData = false;
								this.$toast(`The ICCID ranges were added to this carrier. You may now upload your data.`, {type: "success"});
							} else {
								this.invalidData = true;
								this.$toast(res.data.error_string, {type: "error"});
							}
						});
					}
				});

			} else {
				if (JSON.stringify(errors).includes("EXISTING_RANGE") && !JSON.stringify(errors).includes("CARRIER_MISMATCH")) {
					swal.fire({
						title: `EXISTING_RANGE`,
						html: `<div align="left">
									One or more ICCID in this range already exist.<br><br>
									Would you like to override the current range with this one? <br><br>
									<b>carrier:</b> ${carrierDisplayName}<br>
									<b>vendor:</b> ${this.vendorDisplayName}<br>
									<b>first:</b> ${startIccid}<br>
									<b>last:</b> ${endIccid}<br><br>
									ERRORS: ${JSON.stringify(errors).replaceAll("\"", "").replaceAll("[", "<br>").replaceAll("]", "").replaceAll(",", "<br>")}
								</div>`,
						showCloseButton: true,
						showCancelButton: true,
						confirmButtonText: `Overwrite Range`,
						cancelButtonText: "Cancel",
						customClass: {
							cancelButton: "order-1 mr-3",
							confirmButton: "btn btn-danger order-2",
						},
					}).then(result => {
						this.overwriteable = true;
						if (result.isConfirmed) {
							this.invalidData = false;
							this.force = true;
							this.$toast(`Please proceed with overwriting this range.`, {type: "warning"});
						} else {
							this.invalidData = true;
							this.force = false;
							this.$toast(`Please fix the conflicts or continue with overwrite by toggling Force on.`, {type: "error"});
						}
					});
				} else {
					this.invalidData = true;
					let errMsg = `One or more errors are preventing you from uploading the selected data. ERRORS: ${JSON.stringify(errors).replaceAll("\"", "").replaceAll("[", "\n").replaceAll("]", "").replaceAll(",", "\n")}`;
					this.$toast(errMsg, {type: "error"});
				}
			}
		},

		//validate file format and headers
		onLoadFileData(event) {
			if (this.active_carrier !== this.carrier.name) return;
			this.checkRunning = true;
			let upload = null;
			if (event.type === "drop") {
				upload = event.dataTransfer.files;
			} else {
				upload = event.target.files;
			}
			if (upload.length > 0) {
				this.file = upload[0];
				if (this.file) {
					let fileReader = new FileReader();
					fileReader.readAsArrayBuffer(this.file);
					fileReader.onload = e => {
						this.arrayBuffer = fileReader.result;
						let data = new Uint8Array(this.arrayBuffer);
						let arr = [];
						for (let i = 0; i !== data.length; ++i) arr[i] = String.fromCharCode(data[i]);
						let bstr = arr.join("");
						let wb = XLSX.read(bstr, {type: "binary"});
						let first_sheet_name = wb.SheetNames[0];
						let ws = wb.Sheets[first_sheet_name];
						let arraylist = XLSX.utils.sheet_to_json(ws, {raw: false});
						this.importData = arraylist;
						this.importDataLength = arraylist.length;
						this.loadPreviewData();
					};
				} else {
					this.showPreviewData = false;
				}
			}
		},

		formatDataRow(data_in) {
			if (this.active_carrier !== this.carrier.name) return;
			//console.log("formatDataRow", data_in)
			let data_out = [];

			if (this.addEsim) {
				//console.log('addEsim formatting')
				data_in = commonService.NewEsimMapImportKeys(data_in);
				//console.log('mapKeys: ',data_in)
			}
			else {
				data_in = commonService.OtaMapImportKeys(data_in);
				//console.log('mapKeys: ',data_in)
			}

			//validate each field
			Object.keys(data_in).forEach(field => {
				// console.log("field:", field, data_in[field]);
				//add forced defaults
				if (field === "kic" && data_in[field] === "") data_in[field] = this.kic;
				else if (field === "kid" && data_in[field] === "") data_in[field] = this.kid;
				// run validator
				if (!commonService.validateData(field, data_in[field])) {
					data_out[field] = "INVALID DATA: " + data_in[field];
				}
			});
			//console.log('data_out: ',data_out)
			return data_out;
		},

		async processBatchImport() {
			if (!this.importFileValidation || !this.vendorValidation) {
				return false;
			}

			//clear last import
			this.success = [];
			this.errors = [];
			this.reportData = [];
			this.currentCnt = 0;
			this.cancelAction = false;

			this.$bvModal.show(`ota_batch_progress_bar_${this.carrier.name}`);
			this.onProgress = true;
			this.progressStartValue = 5;
			this.setProgressTimer();

			for (let i = 0; i < this.importData.length; i++) {

				this.currentCnt = (i + 1);
				this.totalCnt = this.importDataLength;

				try {
					//console.log("before1:", row);
					//let row = this.formatDataRow(this.importData[i]);
					//console.log("before2:", row);
					//let row = this.importData[i];
					// console.log("before1:", row);

					// let keys = commonService.OtaMapImportKeys(row);
					// // console.log("keys:", keys);
					//
					// if (!row.hasOwnProperty("tls") || row.tls === "") {
					// 	row["tls"] = keys.tls;
					// }

					//format the data row (lowercase keys)
					//row = this.inventoryCleanup(row[0]);
					//row = this.inventoryCleanup(row);
					// console.log("after:", row);

					let row = this.formatDataRow(this.importData[i]);
					this.iccid = row["iccid"];

					if (!this.iccid && !commonService.validateData("iccid", this.iccid)) {
						this.errors.push(i + ":" + this.iccid);
						this.reportData.push({
							ICCID: this.iccid,
							STATUS: "ERROR",
							DETAILS: "Invalid ICCID: " + i + ":" + this.iccid,
						});
					} else {
						let data = {
							type: "inventory",
							method: "add",
							force: this.force ? 1 : 0,
							vendor: this.carrier.vendor,
							carrier: this.carrier.name,
							items: [row],
						};
						//{"type":"ota","force":"1","method":"activate","vendor":"esim","items":[{"iccid":"89114900000000017503","tls":"F3BD6A75DBFAEF6844BED69635050097E30289E0C95FDBAB9CDAB587416C91A0","kic":"B2CCF1D7577D6EE607F2656299AA0D0E","kid":"F74D277017ABA54EC8312F6C8C044C3A","vendor":"esim"}]}
						//{"type":"ota","force":"1","method":"activate","vendor":"esim","items":[{"iccid":"89114900000000017503","tls":"F3BD6A75DBFAEF6844BED69635050097E30289E0C95FDBAB9CDAB587416C91A0","kic":"B2CCF1D7577D6EE607F2656299AA0D0E","kid":"F74D277017ABA54EC8312F6C8C044C3A","vendor":"esim"}]}
						await otaDashboardService.inventory_add(data).then(res => {
							// console.log(res);
							if (res.data.results.length > 0 && !res.data.error_string) {
								this.currentStatus = JSON.stringify(res.data);
								this.success.push(this.iccid);
								this.reportData.push({
									ICCID: this.iccid,
									STATUS: "SUCCESS",
									DETAILS: `${i}. ${JSON.stringify(res.data.results[0].result).replaceAll(",", "//")}`,
								});
							} else {
								this.currentStatus = JSON.stringify(res.data.error_string);
								this.errors.push(this.iccid);
								this.reportData.push({
									ICCID: this.iccid,
									STATUS: "ERROR",
									DETAILS: String(res.data.error_string || i + ": iccid missing"),
								});
							}
						});
					}

				} catch (e) {
					console.error(e);
					this.currentStatus = JSON.stringify(e.message);
					//handle error
					this.errors.push(this.iccid);
					this.reportData.push({
						ICCID: this.iccid,
						STATUS: "ERROR",
						DETAILS: e.message,
					});
				}

				if (this.cancelAction) {
					this.currentStatus = "CANCELLED";
					this.reportData.push({
						ICCID: this.iccid,
						STATUS: "CANCELLED",
						DETAILS: `Cancelled after ${this.iccid}`,
					});
					break;
				}
			}

			this.currentStatus = "";
			this.showProcessingReport();
		},

		confirmRemoveInventory() {
			swal.fire({
				title: `Remove Inventory`,
				html: `<div align="left">
									Are you sure you want to remove the inventory from this carrier? <br><br>
									<b>carrier:</b> ${this.carrier.display_name}<br>
									<b>vendor:</b> ${this.vendorDisplayName}<br><br>
									<b>Records to be deleted:</b> ${this.preview_items.length}<br><br>
								</div>`,
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: `Remove Inventory`,
				cancelButtonText: "Cancel",
				customClass: {
					cancelButton: "order-1 mr-3",
					confirmButton: "btn btn-danger order-2",
				},
			}).then(result => {
				if (result.isConfirmed) {
					this.removeInventoryFromFile();
				}
			});
		},

		async removeInventoryFromFile() {
			if (!this.importFileValidation || !this.vendorValidation) {
				return false;
			}

			//clear last import
			this.success = [];
			this.errors = [];
			this.reportData = [];
			this.currentCnt = 0;
			this.cancelAction = false;

			this.$bvModal.show(`ota_batch_progress_bar_${this.carrier.name}`);
			this.onProgress = true;
			this.progressStartValue = 5;
			this.setProgressTimer();

			for (let i = 0; i < this.importData.length; i++) {

				this.currentCnt = (i + 1);
				this.totalCnt = this.importDataLength;

				try {
					let row = this.importData[i];
					// console.log("before1:", row);

					row = this.inventoryCleanup(row);
					// console.log("after:", row);

					this.iccid = row["iccid"];

					if (!this.iccid && !commonService.validateData("iccid", this.iccid)) {
						this.errors.push(i + ":" + this.iccid);
						this.reportData.push({
							ICCID: this.iccid,
							STATUS: "ERROR",
							DETAILS: "Invalid ICCID: " + i + ":" + this.iccid,
						});
					} else {

						await otaDashboardService.inventory_delete(this.iccid).then(res => {
							// console.log(res);
							if (res.data.result.iccid && !res.data.error_string) {
								this.currentStatus = JSON.stringify(res.data);
								this.success.push(this.iccid);
								this.reportData.push({
									ICCID: this.iccid,
									STATUS: "SUCCESS",
									DETAILS: `${i}. ${JSON.stringify(res.data.result.iccid)}`,
								});
							} else {
								this.currentStatus = JSON.stringify(res.data.error_string);
								this.errors.push(this.iccid);
								this.reportData.push({
									ICCID: this.iccid,
									STATUS: "ERROR",
									DETAILS: String(res.data.error_string || i + ": iccid missing"),
								});
							}
						});
					}

				} catch (e) {
					console.error(e);
					this.currentStatus = JSON.stringify(e.message);
					//handle error
					this.errors.push(this.iccid);
					this.reportData.push({
						ICCID: this.iccid,
						STATUS: "ERROR",
						DETAILS: e.message,
					});
				}

				if (this.cancelAction) {
					this.currentStatus = "CANCELLED";
					this.reportData.push({
						ICCID: this.iccid,
						STATUS: "CANCELLED",
						DETAILS: `Cancelled after ${this.iccid}`,
					});
					break;
				}
			}
			this.currentStatus = "";
			this.showProcessingReport();
		},

		inventoryCleanup(obj) {
			let output = {};
			let newKey = "";
			for (let i in obj) {
				newKey = i
					.toLowerCase()
					.replaceAll("#", "")
					.replaceAll("dp", "p")
					.replaceAll("da", "a")
					.replaceAll("var_out:", "");
				output[newKey] = obj[i];
			}
			return output;
		},

		convertKeysToLowercase(obj) {
			const result = {};
			for (const key in obj) {
				if (obj.hasOwnProperty(key)) {
					const value = obj[key];
					// Convert the key to lowercase
					const lowercaseKey = key.toLowerCase();
					// If the value is an object, recursively convert its keys
					if (typeof value === "object" && value !== null) {
						result[lowercaseKey] = this.convertKeysToLowercase(value);
					} else {
						result[lowercaseKey] = value;
					}
				}
			}
			return result;
		},

		setProgressTimer() {
			this.timer = setInterval(() => {
				this.progressStartValue = this.progressStartValue + (Math.random() * 300) / this.progressStartValue;
				if (this.progressStartValue > 100) {
					this.progressStartValue = 10;
				}
			}, 1000);
		},

		showProcessingReport() {
			setTimeout(() => {
				this.$bvModal.hide(`ota_batch_progress_bar_${this.carrier.name}`);
				this.onProgress = false;
			}, 1000);
			setTimeout(() => {
				this.$bvModal.show(`ota_batch_progress_report_${this.carrier.name}`);
			}, 1500);
		},

		clearData() {
			this.importFile = null;
			this.importData = [];
			this.importDataLength = 0;
			this.preview_items = [];
			this.showPreviewData = false;
			this.overwriteable = false;
			this.invalidData = true;
			this.filter = "";
			this.force = false;
		},

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},

		startPage() {
			return pagination.startPageFunc(this.currentPage, this.perPage);
		},

		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows);
		},
	},

	watch: {
		force() {
			if (this.overwriteable && !this.removeInventory) {
				if (this.force && this.preview_items.length > 0) {
					this.invalidData = false;
				} else {
					this.invalidData = true;
				}
			}
		},
		removeInventory(val) {
			if (val && this.preview_items.length > 0) {
				this.force = false;
				this.invalidData = false;
			} else {
				this.invalidData = true;
				this.loadPreviewData();
			}
		},
	},

};
</script>

<style scoped>
.dropzone {
	border: 2px dashed #ccc;
	padding: 20px;
	text-align: center;
	cursor: pointer;
}

.is-dragging {
	background-color: #f0f8ff; /* Light blue background when dragging */
}

.is-file-over {
	border-color: #87cefa; /* Light sky blue border when file is over */
}
</style>